"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Scenario methods, used to determine how variable values should be modified
 */
var VariableMethods;
(function (VariableMethods) {
    VariableMethods["AttributionScenario"] = "attribution-scenario";
    VariableMethods["ComponentAttributionScenario"] = "component-attribution-scenario";
    VariableMethods["ComponentTargetScenario"] = "component-target-scenario";
    VariableMethods["TargetScenarioCat"] = "target-scenario-cat";
    VariableMethods["RelativeScenario"] = "relative-scenario";
    VariableMethods["RelativeScenarioCat"] = "relative-scenario-cat";
    VariableMethods["ComponentRelativeScenario"] = "component-relative-scenario";
    VariableMethods["AbsoluteScenario"] = "absolute-scenario";
    VariableMethods["AbsoluteScenarioCat"] = "absolute-scenario-cat";
    VariableMethods["ComponentAbsoluteScenario"] = "component-absolute-scenario";
})(VariableMethods = exports.VariableMethods || (exports.VariableMethods = {}));
//# sourceMappingURL=scenario-variable.js.map